<template>
    <div class="mx-auto header-margin">
        <div class="text-center p-2">
            <h3 class="mt-5 text-nowrap">{{ $t('logout.title') }}</h3>
            <p class="mt-5">{{ $t('logout.text') }}</p>
            <div class="text-center mt-5">
                <button type="submit" class="btn btn-primary"  @click="handleOnSubmit">{{ $t('logout.backTopBtn') }}</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'logout-module',

        methods: {
            handleOnSubmit() {
                this.$router.push('/');
            }
        }
    }
</script>

<style scoped>
</style>
